var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "生成计提",
        visible: _vm.dialogVisible,
        width: "640px",
        "close-on-click-modal": false,
        "close-on-press-escape": !_vm.submitting,
        "show-close": !_vm.submitting
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.dynamicRules,
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "岗位", prop: "stationName" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.onStationChange },
                  model: {
                    value: _vm.form.stationName,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "stationName", $$v)
                    },
                    expression: "form.stationName"
                  }
                },
                _vm._l(_vm.stationOptions, function(s) {
                  return _c("el-option", {
                    key: s.value,
                    attrs: { label: s.label, value: s.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "业务月份", prop: "businessMonths" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-start",
                    width: "320",
                    trigger: "click",
                    "popper-class": "business-month-popover"
                  },
                  model: {
                    value: _vm.monthPopoverVisible,
                    callback: function($$v) {
                      _vm.monthPopoverVisible = $$v
                    },
                    expression: "monthPopoverVisible"
                  }
                },
                [
                  _c("div", { staticClass: "month-panel" }, [
                    _c("div", { staticClass: "month-panel-header" }, [
                      _c("i", {
                        staticClass: "el-icon-arrow-left",
                        on: {
                          click: function($event) {
                            return _vm.shiftYear(-1)
                          }
                        }
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.panelYear) + " 年")]),
                      _c("i", {
                        staticClass: "el-icon-arrow-right",
                        on: {
                          click: function($event) {
                            return _vm.shiftYear(1)
                          }
                        }
                      })
                    ]),
                    _c(
                      "div",
                      { staticClass: "month-grid" },
                      _vm._l(12, function(m) {
                        return _c(
                          "div",
                          {
                            key: m,
                            staticClass: "month-cell",
                            class: {
                              selected: _vm.isSelected(_vm.panelYear, m)
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleMonth(_vm.panelYear, m)
                              }
                            }
                          },
                          [_vm._v(" " + _vm._s(m) + "月 ")]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "month-panel-footer" },
                      [
                        _c("span", { staticClass: "selected-count" }, [
                          _vm._v(
                            "已选 " +
                              _vm._s(_vm.form.businessMonths.length) +
                              " 个月"
                          )
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                _vm.form.businessMonths = []
                              }
                            }
                          },
                          [_vm._v("清空")]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "100%", cursor: "pointer" },
                    attrs: {
                      slot: "reference",
                      value: _vm.displayText,
                      readonly: "",
                      placeholder: "请选择业务月份（可多选）",
                      "suffix-icon": "el-icon-date"
                    },
                    slot: "reference"
                  })
                ],
                1
              ),
              _c("div", { staticClass: "tip" }, [
                _vm._v("每选一个月份将生成一个独立批次")
              ])
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "计提月份", prop: "provisionDate" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "month",
                  placeholder: "选择月份",
                  "value-format": "yyyy-MM-dd"
                },
                model: {
                  value: _vm.form.provisionDate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "provisionDate", $$v)
                  },
                  expression: "form.provisionDate"
                }
              })
            ],
            1
          ),
          _vm.isConfigurable
            ? _c(
                "el-form-item",
                { attrs: { label: "提成规则", prop: "ruleUuids" } },
                [
                  _vm.rulesLoading
                    ? _c("div", { staticClass: "tip" }, [
                        _vm._v("正在加载岗位规则…")
                      ])
                    : _vm.enabledRules.length
                    ? _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.form.ruleUuids,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ruleUuids", $$v)
                            },
                            expression: "form.ruleUuids"
                          }
                        },
                        _vm._l(_vm.enabledRules, function(r) {
                          return _c(
                            "el-checkbox",
                            {
                              key: r.uuid,
                              staticClass: "rule-checkbox",
                              attrs: { label: r.uuid }
                            },
                            [
                              _c("span", { staticClass: "rule-name" }, [
                                _vm._v(_vm._s(r.ruleName))
                              ]),
                              _c(
                                "span",
                                { staticClass: "rule-meta" },
                                [
                                  _vm._v(
                                    "（" + _vm._s(_vm.calcTypeLabel(r.calcType))
                                  ),
                                  _vm.shouldShowFixedAmount(r)
                                    ? [
                                        _vm._v(
                                          " " + _vm._s(r.fixedAmount) + "元"
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v("）")
                                ],
                                2
                              )
                            ]
                          )
                        }),
                        1
                      )
                    : _vm.form.stationName
                    ? _c("div", { staticClass: "tip warn" }, [
                        _vm._v(
                          " 该岗位暂无已启用的规则。请先在侧边栏「计提规则配置 → 岗位规则配置」中添加规则，并确认状态为「启用」。 "
                        )
                      ])
                    : _vm._e(),
                  _vm.enabledRules.length
                    ? _c("div", { staticClass: "tip" }, [
                        _vm._v(
                          "勾选本次生成要参与的岗位规则；人员特殊规则仍会自动叠加"
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.submitting },
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.handleSubmit }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.submitting ? "生成中..." : _vm.$t("common.btn.confirm")
                  ) +
                  " "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }